<template>
	<v-card class="event-preview-card elevation-0 d-flex flex-column pb-1">
		<div class="event-preview-card__container">
      <SponsorBadge
          v-if="sponsoredLabel && eventInfo.event_image === null"
          :text="sponsoredLabel"
          :top="'0'"
          :right="'0'"
          :icon="'star'"
          :iconSize="10"
          :iconColor="'#ffffff'"
      />
			<div class="event-preview-card__outer">
				<div class="d-flex event-preview-card__list pl-0 pr-0">
					<div class="d-flex flex-column">
						<div
							v-if="!!eventInfo.event_image"
							class="event-preview-card__preview-image-container u-cursor-pointer"
							@click="toggleToEvent"
						>
							<img
								:src="eventInfo.event_image"
								alt="event-image-previw"
								class="event-preview-card__preview-image-container__preview-image"
							/>
							<SponsorBadge
								v-if="sponsoredLabel"
								:text="sponsoredLabel"
								:top="'12px'"
								:right="'12px'"
								:icon="'star'"
								:iconSize="10"
								:iconColor="'#ffffff'"
							/>
						</div>

						<div class="d-flex flex-column justify-space-around pa-3">
							<div
								@click="toggleToEvent"
								class="event-preview-card__title u-cursor-pointer"
							>
								{{ eventInfo.event_title }}
							</div>

							<div
								@click="toggleToEvent"
								class="event-preview-card__time-title mt-3 d-flex align-end u-cursor-pointer"
							>
								<Icon :size="16" type="union" :color="'#4a4a4a'" />
								<span class="ml-2">
									{{startOnlyLine}}
								</span>
							</div>

							<div
								@click="toggleToEvent"
								class="event-preview-card__location mt-2 u-cursor-pointer"
								v-if="isAddressView"
							>
                <Icon :size="16" type="pin" :color="'var(--location-color)'" />
                  {{getAddressLine}}
							</div>
							<div
								class="event-description__tags flex-wrap mt-3"
								v-if="eventInfo.tags && eventInfo.tags.length"
							>
                <v-chip
                    v-for="(tag, index) in tagView"
                    :class="{
                       'tag-selected': tagChoices(tag.tag_id),
                       'tag-default': !tagChoices(tag.tag_id)
                    }"
                    class="post-preview-card__tag mr-2"
                    :key="index"
                    @click="onTagClick(tag.tag_id)"
                >
                  #{{ tag.tag }}
                </v-chip>

                <div
									v-if="!isAllTag && eventInfo.tags.length > 2"
									@click="tagsToggle"
									class="event-preview-card__more-tags"
								>
									+{{ eventInfo.tags.length - 2 }} more
								</div>
								<div
									v-if="isAllTag && eventInfo.tags.length > 2"
									@click="tagsToggle"
									class="event-preview-card__more-tags"
								>
									hide
								</div>
							</div>
						</div>

						<v-divider />
						<EventRegisterButton
							:isExternal="isExternal"
							:isFollowed="!!isFollowed"
							:bookmarked="!!bookmarked"
							:registerLink="eventInfo.event_register_link"
							:eventId="eventInfo.event_id"
							@follow="onFollow"
							@addToBookmark="addToBookmark"
              @handleExternalRegisterEvent="handleExternalRegisterEvent"
              @handleSeeDetailEvent="handleSeeDetailEvent"
						/>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import pinnedIcon from '@/assets/images/icon-pinned.svg'
import bookmarkedIcon from '@/assets/images/postIcon/icon-bookmarked.svg'
import Dwh from '@/mixins/Dwh'
import EventRegisterButton from '@/components/Event/EventRegisterButtons.vue'
import SponsorBadge from '@/components/SponsorBadge.vue'
import { mapActions, mapGetters } from 'vuex'
import { followEvent, unfollowEvent } from '@/api/event'
import {
  formatEventStartLine,
} from '@/utils/timezone'

Vue.use(VueScrollTo)

export default {
	name: 'EventPreview',
	components: {
		EventRegisterButton,
		SponsorBadge,
	},
	mixins: [Dwh],
	props: {
    eventInfo: {
			type: Object,
			default: () => ({}),
		},
    selectedChips:{
      type: Object,
      default: () => ({}),
    }
	},
	data() {
		return {
			pinnedIcon,
			bookmarkedIcon,
			isFollowed: null,
			bookmarked: null,
			isAllTag: false,
		}
	},
	watch: {
    eventInfo: {
			handler() {
				this.isFollowed = this.eventInfo.is_follow
				this.bookmarked = this.eventInfo.bookmark.is_bookmarked
			},
			immediate: true,
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
    startOnlyLine() {
      return formatEventStartLine(this.eventInfo.event_start, this.eventInfo.eventTimezone, 'en-US');
    },
		currentUser() {
			return this.profile
		},
		tagView() {
			const eventTags = this.eventInfo.tags || []
			return this.isAllTag === false ? eventTags.slice(0, 2) : eventTags
		},
		sponsoredLabel() {
			const sponsor = this.eventInfo.event_sponsor_text
			if (!sponsor) return ''
			const limitedSponsor = sponsor.length > 30 ? sponsor.slice(0, 30) + '…' : sponsor
			return `Sponsored by ${limitedSponsor}`
		},
		isExternal() {
			return this.eventInfo.event_register_link?.startsWith('http')
		},
    isAddressView(){
      return 	this.eventInfo.address &&
          (this.eventInfo.address.address_city ||
              this.eventInfo.address.address_state ||
              this.eventInfo.address.address_country)
    },
    getAddressLine() {
      const a = this.eventInfo.address || {}
      const country = a.address_country === 'United States' ? '' : a.address_country
      const cityLine = [a.address_city, a.address_state, country].filter(Boolean).join(', ')
      return cityLine
    },
	},

	methods: {
		...mapActions('event', ['addEventToSchedule', 'removeEventFromSchedule', 'toggleBookmark']),
    tagChoices(id){
      if (!this.selectedChips || !this.selectedChips.tags) return false
      return this.selectedChips.tags.includes(id)
    },
    async addToBookmark() {
      const newStatus = this.bookmarked ? 0 : 1
      const actionTitle = newStatus === 0
          ? 'click_remove_bookmark_event_list'
          : 'click_bookmark_event_list'

      await this.sendTrigger({
        category: 'Event List',
        action: actionTitle,
        module: 'Events',
        title: this.eventInfo.event_title,
        id1: this.eventInfo.event_id,
      })

      await this.toggleBookmark({
        user_id: this.currentUser.user_id,
        bookmark_entity_type: this.eventInfo.bookmark.bookmark_entity_type,
        bookmark_status: newStatus,
        bookmark_entity_id: this.eventInfo.bookmark.bookmark_entity_id,
      })

      this.bookmarked = newStatus
    },
    onTagClick(tagId) {
			this.$emit('tagClicked', tagId)
		},
		tagsToggle() {
			this.isAllTag = !this.isAllTag
		},
		toggleToEvent() {
			return this.$router.push({
				name: 'event-by-id',
				params: { id: this.eventInfo.event_id },
			})
		},
		handleRegisterEvent() {
			this.sendTrigger({
				category: 'Event List',
				action: 'click_register_event_list',
				module: 'Events',
				title: this.eventInfo.event_title,
        id1: this.eventInfo.event_id,
			})
		},
    handleUnfollowEvent() {
      this.sendTrigger({
        category: 'Event List',
        action: 'click_unregister_event_list',
        module: 'Events',
        title: this.eventInfo.event_title,
        id1: this.eventInfo.event_id,
      })
    },
    handleExternalRegisterEvent() {
      this.sendTrigger({
        category: 'Event List',
        action: 'click_external_register_event_list',
        module: 'Events',
        title: this.eventInfo.event_title,
        id1: this.eventInfo.event_id,
      })
    },
    handleSeeDetailEvent() {
      this.sendTrigger({
        category: 'Event List',
        action: 'click_see_details_event_list',
        module: 'Events',
        title: this.eventInfo.event_title,
        id1: this.eventInfo.event_id,
      })
    },
    handelCalendar(){
      this.sendTrigger({
        category: 'Event List',
        action: 'click_calendar_event_list',
        module: 'Events',
      })
    },
		async onFollow() {
      if (this.isFollowed && !this.isExternal) {
				await unfollowEvent(this.eventInfo.event_id)
        this.handleUnfollowEvent()
			} else if (!this.isFollowed) {
				await followEvent({ event_id: this.eventInfo.event_id })
				this.handleRegisterEvent()
			}
      this.isFollowed = !this.isFollowed
		},
	},
}
</script>
<style lang="scss">
.event-preview-card {
	background: #f1f1f1 !important;
	font-family: 'Inter', sans-serif;
	color: rgb(74, 74, 74);
  .post-preview-card__tag {
    &.tag-selected {
      background-color: var(--secondary_color) !important;

      span {
        color: #ffffff !important;
      }
    }

    &.tag-default {
      background-color: #ffffff !important;

      span {
        color: #4a4a4a !important;
      }
    }
  }
	&__more-tags {
		display: flex;
		align-items: center;
		font-family: 'Inter', sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		border: 1.5px solid #e2e2e2 !important;
		border-radius: 20px;
		cursor: pointer;
		padding: 0 8px;
		color: #4a4a4a;
	}
	&__go-to-event-wrapper {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 12px;
		&__button {
			display: flex;
			width: 100%;
			justify-content: center;
			align-items: center;
			border: 1.5px solid var(--button-secondary-background-color);
			height: 46px;
			border-radius: 8px;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			background-color: #ffffff;
			color: var(--button-secondary-color);
		}
		&__bookmark {
			width: 46px;
			height: 46px;
			border-radius: 8px;
			background-color: #f3f3f6;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
		}
	}

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		background: white !important;
    position: relative;
	}

	&__brief-description {
		font-family: 'Inter', sans-serif;
		font-size: 14px;
		line-height: 17.07px;
		font-weight: 400;
	}

	&__content-inner {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Inter, sans-serif;
		font-weight: normal;
		line-height: 18px;

		img {
			width: 100%;
		}

		p {
			margin-bottom: 0;
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}
	}
	&__preview-image-container {
		width: 100%;
		max-height: 324px;
		height: 100%;
		border-radius: 8px;
		padding: 12px 12px 0 12px;
		position: relative;
		&__preview-image {
			width: 100%;
			max-height: 312px;
			object-fit: cover;
			height: 100%;
			border-radius: 8px;
			@media screen and (max-width: 500px) {
				max-height: 311px;
				height: 100%;
				max-width: 100%;
			}
		}
	}

	&__location {
		display: flex;
    align-items: center;
    gap: 8px;
		color: var(--location-color);
		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
	}

	&__meta {
		font-family: Inter, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 20px;
		color: rgb(66, 160, 216);
		letter-spacing: 0.36px;
		gap: 4px;

		&-bottom {
			color: rgb(155, 155, 155);
			font-size: 16px;
			font-family: Inter, sans-serif;
			font-weight: normal;
			line-height: 16px;

			span {
				min-width: 85px;
			}
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Inter, sans-serif;
			font-weight: normal;
			text-align: right;
		}
	}

	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__outer {
		border-radius: 8px !important;
		border: 1px solid #e2e2e2 !important;
	}

	&__list {
		flex-direction: column;
	}

	&__link {
		color: var(--button-main-background-color);
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;

		a {
			color: var(--button-main-background-color) !important;
		}
	}

	&__title {
    color: var(--username-category-title) !important;
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 20px;
		line-height: 22px;
		letter-spacing: 0;
		a {
			color: #202232 !important;
			text-decoration: none;
		}
	}
	&__time-title {
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
	}
	&__block-view {
		flex-direction: column;
		height: 73%;

		.post-preview-card__thumbnail-outer img {
			max-width: 100%;
		}
	}

	&__content {
		font-family: Montserrat;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 21px;
	}

	&__thumbnail {
		height: auto;
		width: 100%;
		max-height: 143px;
	}

	&__tag {
		padding: 6px;
		border-radius: 3px !important;
		color: rgb(74, 74, 74);
		font-size: 14px !important;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		height: 20px !important;
		cursor: pointer;

		&:hover {
			color: #fff !important;
			background-color: rgb(66, 160, 216) !important;
		}
	}

	&__like-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa;

		&-active {
			color: #db7842 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__share-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa !important;
		cursor: pointer;

		.v-icon {
			transform: rotateY(180deg);
		}

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__book-button {
		color: var(--accent-color);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-decoration: underline;

		&-active {
			color: #0a00a5 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__comment {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		letter-spacing: -0.43px;
		width: 100%;

		&::placeholder {
			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}

		&:focus {
			outline: none;
		}

		&-send {
			width: 38px;
			height: 22px;
			color: rgb(160, 160, 160);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	&__comments-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		display: flex;
		align-items: flex-end;
		color: #aaaaaa;
		cursor: pointer;

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__my-menu {
		margin-top: 20px;
		min-width: 175px !important;
		contain: initial !important;
		overflow: visible !important;

		&:before {
			content: '';
			position: absolute;
			left: 14px;
			top: 0;
			z-index: -1;
			border-radius: 3px;
			transform: translate(0, -50%) rotate(45deg);
			width: 20px;
			height: 20px;
			background: #fff;
			box-shadow: 0 0 11px rgb(0 0 0 / 14%);
		}
	}

	&__menu-dots {
		margin-left: 10px !important;
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			max-height: 250px;
			height: 100%;
			max-width: 100%;
		}
		&__default-thumbnail {
			max-height: 250px;
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

.dropdown-profile {
	padding: 15px;

	&__item {
		min-height: 30px !important;
		padding: 0;
	}

	&__title {
		color: #aaaaaa;
		font-size: 12px !important;
		line-height: 1.4 !important;
		font-family: 'Montserrat', sans-serif !important;
		font-weight: 600 !important;
	}

	&__title:hover {
		text-decoration: underline;
		color: black;
		transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
	}
}
</style>
